// Operaciones · Torniquete
//
// Existe para que soporte no tenga que pedirle a nadie que abra una consola. Se divide
// en cuatro vistas porque son cuatro preguntas distintas, y tenerlas en una sola pantalla
// obligaba a hacer scroll para llegar a la que importaba:
//
//   Estado      ¿está conectado el torniquete? ¿qué pasó en el recinto?
//   Diagnóstico ¿por qué no le abrió a esta persona?
//   Asistencia  ¿quién entró, a qué hora y a qué taller venía?
//   Puertas     cómo se llama cada puerta, y cuál es entrada y cuál salida
//
// Lo que hay que entender para leer todo esto: el QR no autoriza nada. Lo que autoriza es
// la ventana de vigencia de la ficha de la persona en el equipo, y esa la escribe el
// sistema solo, ~20 minutos antes de cada clase. La cédula y el QR de la app llevan el
// mismo dato (el RUT), así que sirven exactamente igual.

import React from 'react';
import { Tabs } from 'antd';
import { ApiOutlined, IdcardOutlined, TeamOutlined, SwapOutlined } from '@ant-design/icons';
import TorniqueteEstado from './TorniqueteEstado';
import TorniqueteDiagnostico from './TorniqueteDiagnostico';
import TorniqueteAsistencia from './TorniqueteAsistencia';
import TorniquetePuertas from './TorniquetePuertas';

export default function Torniquete() {
  return (
    <Tabs
      type="card"
      defaultActiveKey="estado"
      destroyInactiveTabPane
      items={[
        { key: 'estado', label: <span><ApiOutlined /> Estado</span>, children: <TorniqueteEstado /> },
        { key: 'diagnostico', label: <span><IdcardOutlined /> Diagnóstico</span>, children: <TorniqueteDiagnostico /> },
        { key: 'asistencia', label: <span><TeamOutlined /> Asistencia</span>, children: <TorniqueteAsistencia /> },
        { key: 'puertas', label: <span><SwapOutlined /> Puertas</span>, children: <TorniquetePuertas /> },
      ]}
    />
  );
}
